/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'r-edit': {
    width: 19.98,
    height: 19.89,
    viewBox: '0 0 19.98 19.89',
    data: '<path pid="0" fill-rule="evenodd" d="M19.254 5.533L14.44.686c-.908-.915-2.452-.915-3.36 0L1.816 9.922c-.363.274-.545.64-.635 1.097L0 17.787c0 .548.182 1.189.545 1.554.363.366.817.549 1.362.549h.273l6.72-1.189c.454-.091.818-.274 1.09-.64l9.263-9.236c.455-.458.727-1.006.727-1.646 0-.64-.272-1.19-.726-1.646zM8.719 16.873L1.907 18.06l1.18-6.767L9.9 4.527l5.631 5.578-6.811 6.767zm9.263-9.329l-1.271 1.372-5.631-5.578 1.271-1.28c.182-.183.545-.183.818 0l4.813 4.846c.091.092.182.275.182.366 0 .092-.091.183-.182.274z" _fill="#df4545"/>'
  }
})
